import type { Chain } from 'viem'

export const hyperliquid = {
  id: 999,
  name: 'Hyperliquid',
  nativeCurrency: { name: 'Hyperliquid', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.hyperliquid.xyz/evm'] },
  },
  blockExplorers: {
    default: { name: 'HyperEVMScan', url: 'https://hyperevmscan.io' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 13051,
    },
  },
} as const satisfies Chain
